import { useBreakoutRoomSpeakerGql } from './breakoutRoomSpeaker/breakoutRoomSpeakerGql';
import { breakoutRoomSpeakerSchema } from './breakoutRoomSpeaker/breakoutRoomSpeakerSchema';

export const breakoutRoomSpeakerModel = {
  gql: useBreakoutRoomSpeakerGql(),
  schema: breakoutRoomSpeakerSchema,
};
